import {
  TOGGLE_NOTIFICATIONS_PANEL_STATE
} from 'common/notifications/actions/PanelActions';

export default function(state = {}, action) {
  switch (action.type) {
    case TOGGLE_NOTIFICATIONS_PANEL_STATE:
      return {
        ...state,
        showNotificationPanel: action.toggle
      };
    default:
      return state;
  }
}

